module.exports = __webpack_public_path__ + "img/tha.76fca72f.svg";